import React from "react";
import { Route } from 'react-router-dom';
import MainLayout from "../baseApp/shared/components/layout/MainLayout";
import AuthenticationRoute from "../baseApp/auth/components/AuthenticationRoute";
import MeetingRoomsFormContainer from './meetingRooms/containers/MeetingRoomsFormContainer';
import MeetingRoomsPageContainer from "./meetingRooms/containers/MeetingRoomsPageContainer";
import BuildingsFormContainer from "./buildings/containers/BuildingsFormContainer";
import BuildingsPageContainer from "./buildings/containers/BuildingsPageContainer";
import VisitsPageContainer from "./visits/containers/VisitsPageContainer";
import VisitorsPageContainer from "./visitors/containers/VisitorsPageContainer";
import VisitorsFormContainer from "./visitors/containers/VisitorsFormContainer";
import ConsoleUsersPageContainer from "./consoleUsers/containers/ConsoleUsersPageContainer";
import ConsoleUsersFormContainer from "./consoleUsers/containers/ConsoleUsersFormContainer";
import VisitsFormContainer from "./visits/containers/VisitsFormContainer";
import ParkingListContainer from "./parking/containers/ParkingListContainer";
import ParkingPageContainer from "./parking/containers/ParkingPageContainer";

const routes = [
    <Route
        key='meetingRoomsEditPage'
        path={["/meetingRooms/create", "/meetingRooms/:meetingRoomId"]}
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <MeetingRoomsFormContainer
                        {...props}
                        meetingRoomId={props.match.params.meetingRoomId}
                    />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='meetingRoomsPage'
        path="/meetingRooms"
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <MeetingRoomsPageContainer {...props} />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='buildingsEditPage'
        path={["/buildings/create", "/buildings/:buildingId"]}
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <BuildingsFormContainer
                        {...props}
                        buildingId={props.match.params.buildingId}
                    />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='buildingsPage'
        path="/buildings"
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <BuildingsPageContainer {...props} />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='visitsEditPage'
        path="/currentVisits/create"
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <VisitsFormContainer
                        {...props}
                        visitId={props.match.params.visitId}
                    />
                </MainLayout>
            </AuthenticationRoute>
        )
        }
    />,
    <Route
        key='visitsPage'
        path="/currentVisits"
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <VisitsPageContainer
                        {...props}
                        isPlannedVisits={false}
                        isVisitsHistoric={false}
                    />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='plannedVisitsPage'
        path="/plannedVisits"
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <VisitsPageContainer
                        {...props}
                        isPlannedVisits={true}
                        isVisitsHistoric={false}
                    />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='visitsHistoricPage'
        path="/visitsHistoric"
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <VisitsPageContainer
                        {...props}
                        isPlannedVisits={false}
                        isVisitsHistoric={true}
                    />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='visitorsEditPage'
        path={["/visitors/:visitorId"]}
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <VisitorsFormContainer
                        {...props}
                        visitorId={props.match.params.visitorId}
                    />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='visitorsPage'
        path="/visitors"
        component={props => <AuthenticationRoute>
            <MainLayout {...props} >
                <VisitorsPageContainer {...props} />
            </MainLayout>
        </AuthenticationRoute>
        }
    />,
    <Route
        key='consoleUsersEditPage'
        path={["/consoleUsers/create", "/consoleUsers/:consoleUserId"]}
        component={props => <AuthenticationRoute>
            <MainLayout {...props} >
                <ConsoleUsersFormContainer
                    {...props}
                    consoleUserId={props.match.params.consoleUserId}
                />
            </MainLayout>
        </AuthenticationRoute>
        }
    />,
    <Route
        key='consoleUsersPage'
        path="/consoleUsers"
        component={props => <AuthenticationRoute>
            <MainLayout {...props} >
                <ConsoleUsersPageContainer {...props} />
            </MainLayout>
        </AuthenticationRoute>
        }
    />,
    <Route
    key='parkingPage'
    path={["/parking/:parkingId"]}
    component={props => (
        <AuthenticationRoute>
            <MainLayout {...props} >
            <ParkingPageContainer 
                {...props}
                parkingId={props.match.params.parkingId}/>
            </MainLayout>
        </AuthenticationRoute>
    )}
    />,
    <Route
        key='parkingListPage'
        path="/parking"
        component={props => <AuthenticationRoute>
            <MainLayout {...props} >
            <ParkingListContainer {...props} />
            </MainLayout>
        </AuthenticationRoute>
        }
    />
];
export {
    routes
};
